import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Select from 'react-select';
import './AddressingPopup.css';
import {IoIosCloseCircle} from 'react-icons/io';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {jwtDecode} from "jwt-decode";
import {FaUserPlus} from "react-icons/fa";
import CaseUserStatus from "../../../enums/CaseUserStatus";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";

const AddressingPopupAdmin = ({roleName, onManagerAdded, caseDataDays, departmentId}) => {
    const token = localStorage.getItem('jwtToken');
    const decodedToken = jwtDecode(token);
    const userId = decodedToken.sub;
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUserIdRole, setSelectedUserRole] = useState('');
    const [selectedUserIdDepartment, setSelectedUserDepartment] = useState('');
    const [users, setUsers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dedlineDays, setDedlineDays] = useState(parseInt(caseDataDays) > 0 ? caseDataDays : '');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});
    const [departments, setDepartments] = useState([]);
    const [selectedUserViewerOptions, setSelectedUserViewerOptions] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(departmentId);



    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setShowPopup(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showPopup]);

    const fetchUserDetails = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
            const data = response.data;
            return data.data;
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        if (roleName === "HEADOFDEPARTMENT") {
            const getUserDetails = async () => {
                const headOfDepartmentInfo = await fetchUserDetails(userId);
                if (headOfDepartmentInfo) {
                    setSelectedDepartment(headOfDepartmentInfo.departmentId);
                }
            };
            void getUserDetails();
        }
    }, [roleName, userId]);





    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDepartament`);
                const allDepartmentsOption = [{id: null, name: "ყველა დეპარტამენტი"}];
                setDepartments(allDepartmentsOption.concat(response.data.data));

            } catch (error) {
            }
        };
        void fetchDepartments();
    }, []);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetAllInternalUsers`);
                let users = response.data.data.result.filter(user => user.roleName !== "HeadOfAgency" && (user.departmentId === departmentId || user.roleName === "DeputyHeadOfAgency"));

                const rolePriority = {
                    'HeadOfAgency': 1,
                    'DeputyHeadOfAgency': 2,
                    'HeadOfDepartment': 3,
                    'Expert': 4
                };

                users.sort((a, b) => {
                    if (rolePriority[a.roleName] !== rolePriority[b.roleName]) {
                        return rolePriority[a.roleName] - rolePriority[b.roleName];
                    } else {
                        return a.firstName.localeCompare(b.firstName);
                    }
                });

                if (roleName === "HEADOFAGENCY" || roleName === "ROOTADMIN") {
                    setUsers(users);
                } else if (roleName === "DEPUTYHEADOFAGENCY") {
                    const deputyUsers = users.filter(user => user.roleName !== "DeputyHeadOfAgency");
                    setUsers(deputyUsers);
                } else {
                    const currentUser = users.find(user => user.id === userId);
                    let departmentUsers = [];
                    let headOfDepartments = [];

                    if (currentUser) {
                        departmentUsers = users.filter(user => user.departmentId === currentUser.departmentId && user.id !== userId);
                        headOfDepartments = users.filter(user => user.roleName === "HeadOfDepartment" && user.id !== userId);
                        const filteredUsers = [...departmentUsers, ...headOfDepartments.filter(hod => !departmentUsers.some(du => du.id === hod.id))];
                        setUsers(filteredUsers);
                    }
                }
            } catch (error) {
            }
        };
        void fetchUsers();
    }, [userId, roleName, token]);

    const formatUserOptions = (users) => {
        return users
            .filter(user => selectedDepartment === null || user.departmentId === selectedDepartment || user.roleName === "DeputyHeadOfAgency")
            .filter(user => !selectedUserViewerOptions.some(viewer => viewer.value === user.id)) // Filter out selected viewer users
            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };


    const handleUserChange = (selectedOption) => {
        setSelectedUserId(selectedOption ? selectedOption.value : '');
        setSelectedUserRole(selectedOption ? selectedOption.role : '');
        setSelectedUserDepartment(selectedOption ? selectedOption.departmentId : '');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const deadline = parseInt(dedlineDays, 10);
        if (!selectedUserId || isNaN(deadline) || deadline <= 0 || deadline > 100) {
            return;
        }
        const uncheckedCount = selectedUserViewerOptions.filter(option => !option.isChecked).length;
        if (uncheckedCount === 1) {
            setShowConfirmationModal(true);
        }
        setShowConfirmationModal(true);
    };

    const handleConfirm = async () => {
        setLoading(true);

        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseUser`;
        const caseId = new URLSearchParams(window.location.search).get('id');
        const payload = {
            caseId: caseId ? parseInt(caseId, 10) : 0,
            toUserId: selectedUserId,
            dedlineDays: parseInt(dedlineDays, 10),
            status: 0,
            addedBySystem: false,
            caseUserType: CaseUserStatus.CaseUser
        };

        try {
            const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");
            const headOfDepartment = users.find(user => user.roleName === "HeadOfDepartment" && user.departmentId === selectedUserIdDepartment);

            if ((selectedUserIdRole === "HEADOFDEPARTMENT" || selectedUserIdRole === "EXPERT") && roleName !== "DEPUTYHEADOFAGENCY" && roleName !== "HEADOFDEPARTMENT") {
                if (deputyHeadOfAgency) {
                    const payload = {
                        caseId: caseId ? parseInt(caseId, 10) : 0,
                        toUserId: deputyHeadOfAgency.id,
                        dedlineDays: parseInt(dedlineDays, 10),
                        status: 0,
                        addedBySystem: true,
                        caseUserType: CaseUserStatus.CaseUser
                    };

                    await axios.post(apiUrl, payload);
                    const caseNotification = {
                        nextStepUserId: deputyHeadOfAgency.id,
                        caseId: caseId ? parseInt(caseId, 10) : 0,
                        documentId: null,
                        action: CaseNotificationEnum.added.id,
                        caseStatus: 8,
                        viewed: false
                    };

                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                }
            }

            if (selectedUserIdRole === "EXPERT" && roleName !== "HEADOFDEPARTMENT") {
                if (headOfDepartment) {
                    const payload = {
                        caseId: caseId ? parseInt(caseId, 10) : 0,
                        toUserId: headOfDepartment.id,
                        dedlineDays: parseInt(dedlineDays, 10),
                        status: 0,
                        addedBySystem: true,
                        caseUserType: CaseUserStatus.CaseUser
                    };

                    const caseNotification = {
                        nextStepUserId: headOfDepartment.id,
                        caseId: caseId ? parseInt(caseId, 10) : 0,
                        documentId: null,
                        action: CaseNotificationEnum.added.id,
                        caseStatus: 8,
                        viewed: false
                    };

                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);

                    await axios.post(apiUrl, payload);
                }
            }

            let addedHeadOfDepartments = [];
            let addedHeadOfDepartmentsNotifications = [];

            selectedUserViewerOptions.sort((a, b) => (b.isChecked === true) - (a.isChecked === true));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const headOfDepartment = users.find(user => user.roleName === "HeadOfDepartment" && user.departmentId === viewer.departmentId);

                if (viewer.role === "EXPERT" && roleName !== "HEADOFDEPARTMENT" && headOfDepartment && !addedHeadOfDepartmentsNotifications.includes(headOfDepartment.id)) {
                    const caseNotification = {
                        nextStepUserId: headOfDepartment.id,
                        caseId: caseId ? parseInt(caseId, 10) : 0,
                        documentId: null,
                        action: CaseNotificationEnum.added.id,
                        caseStatus: 8,
                        viewed: false
                    };
                    addedHeadOfDepartmentsNotifications.push(headOfDepartment.id);

                    return axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                }
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const headOfDepartment = users.find(user => user.roleName === "HeadOfDepartment" && user.departmentId === viewer.departmentId);

                if (viewer.role === "EXPERT" && roleName !== "HEADOFDEPARTMENT" && headOfDepartment && !addedHeadOfDepartments.includes(headOfDepartment.id)) {
                    const payloadViewer = {
                        caseId: caseId ? parseInt(caseId, 10) : 0,
                        toUserId: headOfDepartment.id,
                        dedlineDays: null,
                        status: 0,
                        addedBySystem: false,
                        caseUserType: CaseUserStatus.CaseViewer,
                        approver: viewer.isChecked
                    };
                    addedHeadOfDepartments.push(headOfDepartment.id);

                    return axios.post(apiUrl, payloadViewer);
                }
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const payloadViewer = {
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    toUserId: viewer.value,
                    dedlineDays: null,
                    status: 0,
                    addedBySystem: false,
                    caseUserType: CaseUserStatus.CaseViewer,
                    approver: viewer.isChecked
                };

                return axios.post(apiUrl, payloadViewer);
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const caseNotification = {
                    nextStepUserId: viewer.value,
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    documentId: null,
                    action: CaseNotificationEnum.added.id,
                    caseStatus: 8,
                    viewed: false
                };

                return axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
            }));

            await axios.post(apiUrl, payload);

            const caseNotification = {
                nextStepUserId: selectedUserId,
                caseId: caseId ? parseInt(caseId, 10) : 0,
                documentId: null,
                action: CaseNotificationEnum.added.id,
                caseStatus: 8,
                viewed: false
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);

            setShowPopup(false);
            setSelectedUserId('');
            setAlertInfo({show: true, message: 'მენეჯერი წარმატებით დაემატა!', type: 'success'});
            onManagerAdded();

        } catch (error) {
            setAlertInfo({show: true, message: error.toString(), type: 'error'});
        } finally {
            setLoading(false);
            setShowConfirmationModal(false);
        }
    };

    const userOptions = formatUserOptions(users);


    return (
        <div>
            {showPopup && (
                <div className="overlay" onClick={() => setShowPopup(false)}></div>
            )}
            <button
                onClick={() => setShowPopup(true)}
                className="document-buttonn"
            >
                <span style={{marginRight: 15}} className="button-label">დამატება</span>
                <div className="button-icon-container">
                    <span style={{fontSize: 20}} className="button-icon"><FaUserPlus/></span>
                </div>
            </button>

            {showPopup && (
                <div className="popup">
                    <form onSubmit={handleSubmit} className="form-container-user-select">
                        <h4>დეპარტამენტი</h4>
                        <Select
                            style={{cursor: "pointer"}}
                            options={departments.map(department => ({
                                value: department.id,
                                label: department.name
                            }))}
                            value={departments.find(department => department.id === selectedDepartment) ? {
                                value: selectedDepartment,
                                label: departments.find(department => department.id === selectedDepartment)?.name
                            } : null}
                            onChange={selectedOption => setSelectedDepartment(selectedOption ? selectedOption.value : null)}
                            className="search-select-popup"
                            placeholder="აირჩიეთ დეპარტამენტი..."
                            isClearable
                            isSearchable
                            isDisabled={true}
                            noOptionsMessage={() => "არაფერი მოიძებნა"}
                        />
                        <h4>შემსრულებელი</h4>
                        <Select
                            style={{cursor: "pointer"}}
                            options={userOptions}
                            onChange={handleUserChange}
                            className="search-select-popup"
                            placeholder="მოძებნეთ შემსრულებელი..."
                            isClearable
                            isSearchable
                            noOptionsMessage={() => "არაფერი მოიძებნა"}
                        />
                        <h4>დღეების რაოდენობა</h4>
                        <input
                            type="number"
                            value={dedlineDays}
                            onChange={(e) => {
                                let value = e.target.value;
                                if (value === '' || (Number(value) > 0 && !value.includes('-'))) {
                                    setDedlineDays(value);
                                }
                            }}
                            placeholder="დღეების რაოდენობა"
                            className="addressing-popup-deadline"
                            min="1"
                        />


                        {loading ? (
                            <div className="loader"></div>
                        ) : (
                            <button
                                type="submit"
                                className="submit-button"
                                disabled={selectedUserId === '' || dedlineDays === ""}
                            >
                                შენახვა
                            </button>
                        )}
                    </form>
                    <IoIosCloseCircle className="upload-single-close-icon"
                                      onClick={() => setShowPopup(false)}
                    />
                </div>
            )}
            <ConfirmationModal
                isOpen={showConfirmationModal}
                onRequestClose={() => setShowConfirmationModal(false)}
                onConfirm={handleConfirm}
            />
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => setAlertInfo({show: false, message: '', type: ''})}
                />
            )}
        </div>
    );
};

export default AddressingPopupAdmin;
